module.exports = __webpack_public_path__ + "static/img/default-portrait.24e42c23.jpg";